module.exports = __webpack_public_path__ + "static/media/swingFrame_gasket.a40b49eb.png";